<template>
	<div class="KonfirmasiTransfer font-size-sm-9">
		<div class="row mt-0" v-if="transactionDetail.data">
			<div class="col-12">
				<div class="row">
					<CountDown v-if="transactionDetail.data.trx_payment_method == 1" :date="transactionDetail.data.payment_bank.trx_payment_bank_expired_datetime"/>
					<CountDown v-if="transactionDetail.data.trx_payment_method == 2" :date="transactionDetail.data.payment_va.trx_payment_va_expired_datetime"/>
				</div>
			</div>
			<div class="col-12 pl-md-0">
				<div class="row pl-3 pr-3">
					<div class="col-12 col-md-8 offset-md-2 text-left pl-0 pb-1 mt-3 color-black">
						Kode Transaksi
					</div>
				</div>
				<div class="row pl-3 pr-3">
					<div class="col-12 col-md-8 offset-md-2 text-left pl-0 pb-1 font-weight-bold color-black font-size-13 font-size-sm-11 f-lato">
						{{transactionDetail.data.trx_code}}
					</div>
				</div>
				<div class="row pl-3 pr-3">
					<div class="col-12 col-md-8 offset-md-2 text-left pl-0 pb-1 mt-3 color-black">
						Jumlah yang harus dibayar
					</div>
				</div>
				<div class="row pl-3 pr-">
					<div class="col-12 col-md-8 offset-md-2 text-left pl-0 pb-1 font-size-16 font-size-sm-11 color-black font-weight-bold f-lato">
						Rp {{transactionDetail.data.trx_price_grand_total | toNumber}}
					</div>
				</div>
				<div class="row pl-3 pr-3">
					<div class="col-12 col-md-8 offset-md-2 text-left pl-0 pb-1 mt-3 color-black">
						{{transactionDetail.data.trx_payment_method == 1 ? 'Bank Transfer' : 'Virtual Account'}}
					</div>
				</div>
				<div class="row pl-3 pr-">
					<div class="col-12 col-md-8 offset-md-2 text-left pl-0 pb-1 font-size-16 color-black font-weight-bold">
						<h2 class="mb-0 d-flex" v-if="transactionDetail.data.trx_payment_method == 1">
							<div class="col-3 pl-0 mt-n1"><img class="width-90 img-fluid" :src="'/assets/bank/'+transactionDetail.data.payment_bank.trx_payment_bank_choose_bank_account_bank.toLowerCase()+'.svg'" alt=""></div>
							<div class="col-9 col-md-8 font-size-11 font-size-sm-10 color-black pt-2 pl-0">
								<p class="mb-1 f-lato">{{transactionDetail.data.payment_bank.trx_payment_bank_choose_bank_account_no}}</p>
								<p>{{transactionDetail.data.payment_bank.trx_payment_bank_choose_bank_account_bank}}</p>
							</div>
						</h2>
						<h2 class="mb-0 d-flex" v-if="transactionDetail.data.trx_payment_method == 2">
							<div class="col-3 pl-0"><img class="width-90 img-fluid" :src="'/assets/bank/'+transactionDetail.data.payment_va.trx_payment_va_bank.toLowerCase()+'.svg'" alt=""></div>
							<div class="col-9 col-md-8 font-size-12 font-size-sm-10 color-black mt-auto mb-auto ml-md-n4 ml-0">
								<p class="mb-1 f-lato">{{transactionDetail.data.payment_va.trx_payment_va_number}}</p>
							</div>
						</h2>
					</div>
				</div>
			</div>
			<div class="col-md-8 offset-md-2 p-md-0 mt-3 mt-md-4 mb-4" v-if="transactionDetail.data.trx_payment_method == 1">
				<div class="col-12 pl-0 pr-0 color-black">
					Konfirmasi Pembayaran
				</div>
				<div class="col-12 p-0 mt-3">
					<select @focus="() => konfirmResponse.data.from_bank_name = ''" class="form-control font-size-sm-9 box-purple" v-model="paramBayar.bank_name" name="bank_name">
						<option value="" disabled selected hidden>Bank</option>
						<option v-for="(bank, index) in dataBank" :key="index" :value="bank.bank_name">{{bank.bank_name}}</option>
					</select>
					<Alert empty :content="konfirmResponse.data.from_bank_name"/>
				</div>
				<div class="col-12 p-0 mt-3">
					<input @focus="() => konfirmResponse.data.from_bank_account_no = ''" v-model="paramBayar.nomorRekening" type="text" class="form-control font-size-sm-9 box-purple f-lato" placeholder="Nomor Rekening" @keypress="onlyNumber">
					<Alert empty :content="konfirmResponse.data.from_bank_account_no"/>
				</div>
				<div class="col-12 p-0 mt-3">
					<input @focus="() => konfirmResponse.data.from_bank_account_name = ''" v-model="paramBayar.namaRekening" type="text" class="form-control font-size-sm-9 box-purple" placeholder="Nama Pemilik Rekening">
					<Alert empty :content="konfirmResponse.data.from_bank_account_name"/>
				</div>
				<div class="col-12 p-0 mt-3">
					<input @focus="() => konfirmResponse.data.from_bank_branch = ''" v-model="paramBayar.cabang" type="text" class="form-control font-size-sm-9 box-purple" placeholder="Cabang Rekening">
					<Alert empty :content="konfirmResponse.data.from_bank_branch"/>
				</div>
				<div class="col-12 p-0 mt-3">
					<input @focus="() => konfirmResponse.data.transfer_value = ''" v-model="paramBayar.nominal" type="text" class="form-control font-size-sm-9 box-purple f-lato" placeholder="Nominal Transfer" @keypress="onlyNumber">
					<span class="font-size-10 font-italic">Pastikan Anda transfer sesuai dengan Nominal Pembayaran</span>
					<Alert empty :content="konfirmResponse.data.transfer_value"/>
				</div>
				<div class="col-12 p-0 mt-3">
					<input @focus="() => konfirmResponse.data.note = ''" v-model="paramBayar.note" type="text" class="form-control font-size-sm-9 box-purple" placeholder="Keterangan">
					<Alert empty :content="konfirmResponse.data.note"/>
				</div>
				<div class="col-12 p-0 mt-3" @click="scrollDate">
					<datepicker :language="indo" :disabled-dates="disabledDates" @closed="() => konfirmResponse.data.transfer_date = ''" input-class="form-control font-size-sm-8 box-purple scroll-date" v-model="paramBayar.transfer_date" placeholder="Tanggal Transfer" bootstrap-styling calendar-button calendar-button-icon="fa fa-calendar-alt"></datepicker>
					<Alert empty :content="konfirmResponse.data.transfer_date"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CountDown from '@/views/CountDown'
import Datepicker from 'vuejs-datepicker'
import Alert from '@/components/Alert'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import $ from 'jquery'
import {id} from 'vuejs-datepicker/dist/locale'

export default {
	name: 'KonfirmasiTransfer',
	components: {
		CountDown, Alert, Datepicker
	},

	props:{
		paramKonfirm:{
			type: Object
		},
		paramBayar: {
			type: Object
		},
	},

	data(){
		return{
			indo: id,
			transactionData:'',
			countMe:'',
		}
	},

	computed:{
		...mapState('transactionMember', ['transactionDetail', 'konfirmResponse', 'dataBank']),
		...mapGetters('auth', ['isAuth']),
		disabledDates() {
			let date = {
				to: new Date(Date.parse(this.transactionDetail.data.trx_datetime) - 8640000),
				from: new Date(Date.now())
			}
			return date
		}

	},
	methods: {
		...mapMutations('transactionMember', ['resetKonfirmResponse']),
		...mapActions('transactionMember', ['getDataBank']),

		onlyNumber($event) {
			let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

			if ((keyCode < 48 || keyCode > 57) && keyCode!==8) {
				$event.preventDefault();
			}
		},
		scrollDate() {
			var sd = $('.scroll-date').offset().top
			sd += 50
			$('.body-modal').scrollTop(sd)
		},
	},

	created(){
		this.getDataBank()
		this.paramBayar.bank_name=''
		this.paramBayar.namaRekening=''
		this.paramBayar.nomorRekening=''
		this.paramBayar.cabang=''
		this.paramBayar.transfer_date=''
		this.paramBayar.note=''
	},

	watch: {
		transactionDetail() {
			if(this.transactionDetail.data.trx_price_grand_total) {
				this.paramBayar.nominal= this.transactionDetail.data.trx_price_grand_total
			}
		}
	}
}

</script>

<style scoped>
.bank-selected {
	font-size: 14pt;
	font-weight: bold;
}
.date{
	min-height: 300px;
}
.vdp-datepicker {
	padding:0px;
}
.vdp-datepicker input {
	background-color: #ffffff!important;
}
.vdp-datepicker .input-group-text {
	color: #ffffff !important;
	background-color:#9d27c0 !important;
	border: 1px solid#9d27c0 !important;
}
</style>